import { DOCUMENT } from '@angular/common';
import { Component, OnInit,Inject } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';
import { AuthService } from '../../../services/auth.service';
import { SearchService } from '../../../services/search.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.css']
})
export class MyAccountComponent implements OnInit {
  	private readonly notifier: NotifierService;
  	accountDetail:any = [];
    responseAPIstatus: boolean = false;
    showHoldCancelStatus: boolean = false;
    showReviewModal: boolean = false;
    showAddFormStatus: boolean = false;
  	saveReviewStatus : boolean = false;
  	isWriteReview : boolean = false;
    librarySetting:any = [];
  	titleForReview:any = [];
    reviewCategories : any =[];
    userDetail: any = [];
    regionalSetting:any;
    dateFormat:string = 'M/d/yyyy';
    dateTimeFormat:string = 'M/d/yyyy HH:mm:ss';
    viewRefresh =true;
    sortWith:string= 'author';
    orderBy:string='asc'
    myAccountdata: Response;
  	constructor(@Inject(DOCUMENT) private document: Document, private authService: AuthService, private searchService: SearchService, private homepageService: HomepageService, private router: Router, private cookieService: CookieService,notifierService: NotifierService, private activatedRoute: ActivatedRoute )
  	{
  	 	this.notifier = notifierService;
   	}
      
  ngOnInit() {
  	this.document.body.classList.add('inner-page');
    this.document.body.classList.remove('list');
    this.librarySetting  = this.homepageService.getUpdatedConfig();
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem('info') != null){
      // this.userDetail = JSON.parse(this.cookieService.get( 'info')).detail;
      this.userDetail = JSON.parse(localStorage.getItem('info')).detail;
    	this.getAccountDetail(this.sortWith, this.orderBy);
    } else {
    	this.notifier.notify( 'error', 'Please Login to see account detail');
    	this.router.navigate(['/']);
    }
    this.homepageService.getReviewCategories().subscribe((data)=>{
      this.reviewCategories = data;                                                                                                                                                           
    });
    this.regionalSetting = this.homepageService.getGlobalRegionalSetting();
    this.dateFormat = this.homepageService.formatDate();
    this.dateTimeFormat = this.homepageService.formatDateTime();
    if(this.cookieService.check( 'patronPermissions' ) ){
      var permissions = JSON.parse(this.cookieService.get( 'patronPermissions' ));        
      this.isWriteReview = permissions.opacWriteReview;
    }
  }
  
  getAccountDetail(sortBy, order){
    if(sortBy)
    this.sortWith = sortBy; 
    this.viewRefresh= false;
  	var token = localStorage.getItem('token');
  	this.homepageService.getAccountDetail(token, this.sortWith, this.orderBy).subscribe((data:any) => {
  		this.responseAPIstatus = true;
  		if(!data.status){
  			this.notifier.notify( 'error', data.message);
  			this.router.navigate(['/']);
  		} else {
  			this.accountDetail = data.data;  
  		}
  	},(error)=>{
        this.accountDetail = null;
        this.responseAPIstatus = true;
        this.notifier.notify( 'error', "Something went wrong.");
      // }
    });
  }

    imageError(event){
      $('body').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
      $('body').find('img[custom="'+event+'"]').remove();
    }
  
  imageLoad(event, images) {
    if($('body').find('img[custom="'+event+'"]').attr('loaded') == 'yes') {
      return false;
    }
     var sizes = ['xl','l','m','s','xs','xxs'];   
     var imagesAll = [];
     sizes.forEach((evt) => {
      images.forEach((img) => {
        if(img.size == evt){
          imagesAll.push(img.url);
        }
      });      
    });   

    setTimeout(function() {
      if(typeof(imagesAll[0]) != 'undefined') {
        $('body').find('img[custom="'+event+'"]').attr('src',imagesAll[0]);
        $('body').find('img[custom="'+event+'"]').attr('loaded','yes');        
      } 
    },10);
  }

  imageError1(event,images){
    //console.log(event)
    if(typeof($('body').find('img[custom="'+event+'"]').attr('index')) != 'undefined' &&  parseInt($('body').find('img[custom="'+event+'"]').attr('index')) > 0 ){
      var index:number = parseInt($('body').find('img[custom="'+event+'"]').attr('index'));
      if(typeof($('body').find('img[custom="'+event+'"]').attr('loaded')) != 'undefined')
      index--;
      this.imageLoad1(event, images,index, true);
    } else {
      $('body').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
      $('body').find('img[custom="'+event+'"]').remove();          
    }
  }

  imageLoad1(event, images,index, fromError = false) {
    if($('body').find('img[custom="'+event+'"]').attr('loaded') == 'yes' && !fromError) {
      return false;
    }
    if($('body').find('#'+event).length <= 0) {
       $('body').append('<img id="'+event+'" src="" style="display:none;">');
    }
    var $this = this;
    var imagesAll = this.searchService.sortedImage(images);
    $('#'+event).attr('src',imagesAll[index]);
    setTimeout(function(){
      var tempWidth = $('#'+event).width();
      var temp = document.getElementById(event);
      if(tempWidth <= 1 && index > 0){
        $this.imageLoad1(event,images,index-1, true);
        return false;
      }else if(tempWidth <= 1 && index == 0){
        $('body').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
        $('body').find('img[custom="'+event+'"]').remove();
      }
    },500);
    if(typeof(imagesAll[index]) != 'undefined') {
      $('body').find('img[custom="'+event+'"]').attr('src',imagesAll[index]);
      $('body').find('img[custom="'+event+'"]').attr('loaded','yes');        
      $('body').find('img[custom="'+event+'"]').attr('index',index);        
    }
  }

  renewTitle(event,cirOutId){
    var sessionId:any = 0;
    if(event.target.nodeName == 'BUTTON'){
      var selector =  $(event.target);
    } else {
      var selector =  $(event.target).parent();
    }
    selector.html('Wait...').attr('disabled','disabled');
    if(this.cookieService.check( 'renewSession') ){
      var sessionId:any = this.cookieService.get( 'renewSession');    
    }
    var token = localStorage.getItem('token');
    this.homepageService.titleRenew(sessionId, cirOutId, token).subscribe((data:any) => {
      if(data.status){
        this.cookieService.set( 'renewSession', data.data.sessionId, 365,'/'); 
        var message = data.message+' successfully';
        if(parseFloat(data.data.fine) > 0 ){
          message += ', Your fine is '+this.currencyHelper(data.data.fine);
        }
        this.notifier.notify( 'success', message);
        this.getAccountDetail(this.sortWith, this.orderBy);
      } else {
        selector.html('<i class="fa fa-refresh"></i> Renew').removeAttr('disabled');
        this.notifier.notify( 'error', data.message);
      }
    },(err:any) => {
           selector.html('<i class="fa fa-refresh"></i> Renew').removeAttr('disabled');
        this.notifier.notify( 'error', err.error.message);
    });
  }

  cancelHold(event, circHoldId){
    $('a[href="#write-cancel-holds'+circHoldId+'"]').attr('disabled','disabled').html('Wait...');
    $('#cancelholdsClose'+circHoldId).trigger('click');
    var token = localStorage.getItem('token');
    this.homepageService.cancelHoldAccount(circHoldId, token).subscribe((data:any) => {
      if(data.status){
        this.notifier.notify( 'success', data.message+' successfully');
        $(event.target).parents('.book-box').remove();
      } else {
        this.notifier.notify( 'error', data.message);
        $(event.target).removeAttr('disabled').html('<i class="fa fa-times"></i> Cancel Hold');
      }
    },(error)=>{
         this.notifier.notify( 'error', "Something went wrong.");
        $(event.target).removeAttr('disabled').html('<i class="fa fa-times"></i> Cancel Hold');
    });
  }

  checkReviewStatus(event, id, index, type){
    event.preventDefault();
    this.titleForReview['id'] = id;    
    this.titleForReview['index'] = index;    
    this.titleForReview['type'] = type;    
    this.showReviewModal = true;    
  }

  closeReviewStatus(){
      this.showReviewModal = false;   
  }

  starRatingTitle(event){
    if(typeof(event.rating) == 'number'){
      var patronId:any = null;
    //if(this.cookieService.check( 'info')){
      if (localStorage.getItem('info') != null){
        var token = localStorage.getItem('token');
        //this.userDetail = JSON.parse(this.cookieService.get( 'info')).detail;
        var patronId:any = JSON.parse(localStorage.getItem('info')).detail.patronId;
      } else if(this.librarySetting.data.settings.ratings.loginRequired){
        this.notifier.notify( 'warning', 'You need to login to rate resources');
        return false;
      }
      
      this.homepageService.addStarRating(this.titleForReview['id'],event.rating,patronId,token).subscribe((data:any) => {
        if(data.status){
          this.showReviewModal = false;
          if(this.titleForReview['type'] == 'onloan'){
            this.accountDetail.onLoan[this.titleForReview['index']].ratings.stars = event.rating;
            this.accountDetail.onLoan[this.titleForReview['index']].ratings.count++;
          } else {
            this.accountDetail.holds[this.titleForReview['index']].ratings.stars = event.rating;            
            this.accountDetail.holds[this.titleForReview['index']].ratings.count++;            
          }
          this.notifier.notify( 'success', 'Rating has been updated successfully');
        } else {
          this.showReviewModal = false;
          this.notifier.notify( 'error', data.message);
        }
      },(err) => {
          this.notifier.notify( 'error', 'Something went wrong.Try again.');   
      });
    }
  }

  showAddForm(event,resourceId,title,author,index){
    event.preventDefault();
    //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
      var token =  localStorage.getItem('token');
      this.homepageService.isReviewedByPatron(token, resourceId).subscribe((data:any) => {
        if(!data.data.isReviewed){
          this.titleForReview['id'] = resourceId;    
          this.titleForReview['title'] = title;    
          this.titleForReview['author'] = author;
          this.titleForReview['index'] = index;
          this.showAddFormStatus = true;
        } else{
          this.notifier.notify( 'error', 'The patron already review the title');   
        }
      });
    } 
    
  }


  onRatingChange(event){
    $('#reviewStar').val(event.rating);
    $(document).find('.messageReview.error').remove();
  }


saveReview(){
    var error= 0;    
    let resourceId:any = parseInt(this.titleForReview['id']);
    //var patronId:any = JSON.parse(this.cookieService.get( 'info')).detail.patronId;
    var patronId:any = JSON.parse(localStorage.getItem('info')).detail.patronId;
    var title = this.titleForReview['title'];        
    var author = this.titleForReview['author'];
    let ratingStar:any = 0;
    var reviewText = $('#reviewText').val();
    if(this.librarySetting.data.settings.ratings.enabled){
      ratingStar = parseFloat($('#reviewStar').val().toString());
      if(ratingStar == 0){
        if($('#reviewStar').parent().find('.messageReview').length == 0){
        $('#reviewStar').parent().append('<span class="messageReview error ratingError">Please give rating</span>');
        }
        setTimeout(function(){
          $(document).find('.messageReview').remove();
        },5000);
        error++;
      }
    }
    if($.trim(reviewText.toString()) == ''){
      $('#reviewText').addClass('error');
      setTimeout(function(){
        $(document).find('#reviewText').removeClass('error');
      },5000);
      error++;
    }
    var reviewer = $('#reviewerName').val();
    if($.trim(reviewer.toString()) == ''){
      $('#reviewerName').addClass('error');
      error++;
    }    
    var categories = [];
    if($('.reviewCategory').find('input[type="checkbox"]:checked').length > 0){
      $('.reviewCategory').find('input[type="checkbox"]:checked').each(function(){
        categories.push( parseInt($(this).val().toString()) );
      });
    } else {
      if($('.reviewCategory').find('.reviewCatError').length == 0){
      $('.reviewCategory').find('.clearfix').after('<span class="reviewCatError" style="text-align:left; padding-left:15px;">Select at least one category</span>');
      }
      setTimeout(function(){
        $(document).find('.reviewCatError').remove();
      },5000);
      error++;  
    }

    if(error != 0){
      return false;
    }
    this.saveReviewStatus = true;
    var auth =  localStorage.getItem('token');  
    this.homepageService.addReview(resourceId, patronId, title, author, ratingStar, reviewText, reviewer, categories, auth ).subscribe((data) => {
      if(this.librarySetting.data.settings.ratings.enabled){
        if(this.titleForReview['type'] == 'onloan'){
          this.accountDetail.onLoan[this.titleForReview['index']].ratings.stars = ratingStar;
          this.accountDetail.onLoan[this.titleForReview['index']].ratings.count++;
        } else {
          this.accountDetail.holds[this.titleForReview['index']].ratings.stars = ratingStar;            
          this.accountDetail.holds[this.titleForReview['index']].ratings.count++;            
        }
      }
      this.notifier.notify( 'success', 'The review has been submitted for publication' );      
      $('#closereviewAdd').trigger('click');             
      this.saveReviewStatus = false;
    },(err) => 
    {
      if(err.status == 400){
        this.saveReviewStatus = false;
        this.notifier.notify( 'error', err.error.message );  
        $('#closereviewAdd').trigger('click');             
      }else {
        this.notifier.notify( 'error', "Something went wrong.");
      }
    });
  }

  hideReviewModal(){
    this.showAddFormStatus = false;    
  }

  currencyHelper(cost){
    return this.homepageService.formatCurrency(cost);
  }
  getListSort(sortBy, order) {
    if(this.sortWith == sortBy){
      if(this.orderBy == 'asc'){
        this.orderBy = 'desc';
      }else{
        this.orderBy = 'asc';
      }
    }else{
      this.sortWith = sortBy;
    }
    this.viewRefresh = true;
    var token = localStorage.getItem('token');

    //this.getAccountDetail(sortBy);
    
    return this.homepageService.getAccountDetail(token,this.sortWith, this.orderBy).subscribe((data:any) => {
      this.viewRefresh = false;
      this.accountDetail = data.data;
      this.router.navigate(
        [],
        {
          relativeTo: this.activatedRoute,
          queryParams: {
            sortBy: this.sortWith,
            order: this.orderBy
          },
          queryParamsHandling: "merge"
        }
      )
    });
  }

}
